<mat-card class="error-card" *ngIf="(message || '') != ''">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>error</mat-icon>
            Error !
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        {{ message }}
    </mat-card-content>
</mat-card>